"use client"

import { useCartState } from "src/checkout/hooks/useCart"
import { setCartSidebarVisible } from "src/components/np-design/sections/cart-sidebar/state"
import { routes } from "src/config/routes"
import { NpHeaderIconLink } from "./NpHeaderIconLink"

export const NpHeaderCartLink = () => {
  const cart = useCartState()

  const totalItemsInCart = cart.data?.items.reduce((sum, item) => sum + item.quantity, 0)
  const notification = totalItemsInCart ? totalItemsInCart.toString() : undefined

  return (
    <NpHeaderIconLink
      href={routes.cart}
      title="Warenkorb"
      iconName="shopping_cart"
      notification={notification}
      onClick={(event) => {
        if (event.button === 0) {
          event.preventDefault()
          setCartSidebarVisible(true)
        }
      }}
    />
  )
}
